// page : '/obsrec/sitelist'

// react redux react-redux history react-router-dom
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import { NavLink } from 'react-router-dom';
// material-ui
import { Typography, Paper, List, ListItemText, ListItem } from '@material-ui/core';
// parts
import { CloseBackButton } from '../parts/CloseBackButton';
// models
// redux
import { IAppState } from '../../redux/modules';
import { siteInfoListObsrecOperations } from '../../redux/modules';
import { SiteInfoListObsrecState } from '../../redux/modules/siteInfoListObsrec';

interface OwnProps {
  listSiteInfo: () => void;
  clear: () => void;
  siteInfoListObsrec: SiteInfoListObsrecState;
  history: H.History;
}

class SelectSiteObsrecPage extends React.Component<OwnProps>{
  componentWillMount() {
    this.props.listSiteInfo();
  }
  render() {
    return (
    <div>
      <Typography variant="h6">[観察記録]-対象の工事現場を選択</Typography>
      <Paper style={{ padding: '10px' }}>
        <List>
            {this.props.siteInfoListObsrec.items.map((item, index) => {
              return (
                <NavLink
                  key={`link_${index}`}
                  style={{textDecoration: 'none', color: 'unset'}}
                  to={`/obsrec/kansatsukiroku/${item.koujiBangou}`}
                >
                  <ListItem
                    button
                    divider
                    key={item.koujiBangou}
                  >
                    <ListItemText
                      primary={item.name}
                      secondary={item.koujiBangou}
                    />
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      </Paper>
      <CloseBackButton history={this.props.history} />
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    listSiteInfo: () => {
      siteInfoListObsrecOperations.list()(dispatch);
    },
    clear: () => {
      siteInfoListObsrecOperations.clear()(dispatch);
    },
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    siteInfoListObsrec: appState.siteInfoListObsrec,
    user: appState.user
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectSiteObsrecPage);



// WEBPACK FOOTER //
// ./src/components/obsrec/SelectSiteObsrecPage.tsx